import { render } from "./EditAlerteSMSContactsView.vue?vue&type=template&id=47b416cd&scoped=true"
import script from "./EditAlerteSMSContactsView.vue?vue&type=script&lang=js"
export * from "./EditAlerteSMSContactsView.vue?vue&type=script&lang=js"

import "./EditAlerteSMSContactsView.vue?vue&type=style&index=0&id=47b416cd&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b416cd"]])

export default __exports__